import { SET_EMAIL_RECEIVERS, SET_EMAIL_RECEIVERS_LOADING } from './types'

const initialState = {
  loading: false,
  data: [],
}

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_EMAIL_RECEIVERS:
      return {
        ...state,
        data: action.payload,
      }

    case SET_EMAIL_RECEIVERS_LOADING:
      return {
        ...state,
        loading: action.payload,
      }

    default:
      return state
  }
}
